import React from 'react';

import styled from 'styled-components';
import { ColorPalette } from 'theme/colors';

export const Container = styled.section`
  padding: 12px 14px;
  border-radius: 16px;
  box-shadow: 0 2px 16px 0 ${({ theme }) => theme.travelDetails.flightsShadow};
  background-color: ${({ theme }) => theme.travelDetails.background};
`;

export const Title = styled.h5`
  font-weight: 600;
  font-size: 14px;
  line-height: 1.71;
  color: ${({ theme }) => theme.travelDetails.sectionsTitle};
`;

export const Total: any = styled.div`
  margin-top: 18px;
`;

export const Header: any = styled.div`
  display: flex;
  margin-bottom: 18px;
`;

export const TextCol: any = styled.div`
  display: table-cell;
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.33;
  letter-spacing: normal;
  color: ${ColorPalette.HEX.Manatee2};
  width: 20%;
  min-width: 100px;
`;

export const Division = styled.hr`
  height: 1px;
  border: 0 none;
  color: ${({ theme }) => theme.flightDetails.price.division};
  background-color: ${({ theme }) => theme.flightDetails.price.division};
`;

interface TotalAreaStyledProps {
  styledProps: {
    isExceeded: boolean;
  };
}

Total.Area = styled(({ styledProps, ...rest }: TotalAreaStyledProps) => <div {...rest} />)`
  display: flex;
  justify-content: space-between;
  ${({ styledProps, theme }) => `
        & > h5 {
            color: ${theme.travelDetails.color};
        }
    `}
`;

Total.Text = styled.h5`
  font-size: 12px;
`;

Total.Value = styled.h5`
  font-size: 14px;
  text-align: right;
`;
